'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { toast } from 'sonner';

const toastFnMap = {
  success: toast.success,
  error: toast.error,
  message: toast,
} as const;

export function FlashMessage() {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const message = searchParams?.get('flash_message');
  const type = searchParams?.get('flash_type') ?? 'message';

  useEffect(() => {
    if (!message) return;

    const showToast = toastFnMap[type as keyof typeof toastFnMap] ?? toast;
    showToast(message);

    const newParams = new URLSearchParams(searchParams?.toString() || '');
    newParams.delete('flash_message');
    newParams.delete('flash_type');

    const newUrl = `${pathname}${newParams.toString() ? `?${newParams}` : ''}`;
    router.replace(newUrl);
  }, [message, type, router, pathname, searchParams]);

  return null;
}
